import { useEffect } from 'react';
import { analytics } from '../../../firebase';
import { logEvent } from 'firebase/analytics';

export default function TicTacToePrivacyPolicy() {
  useEffect(() => {
    logEvent(analytics, 'page_view', {
      page_title: 'Privacy Policy, Tic Tac Toe – Infinite',
      page_location: window.location.href,
      page_path: window.location.pathname
    });
  }, []);

  return (
    <div style={{
      fontFamily: "'Segoe UI', 'Helvetica Neue', Arial, sans-serif",
      backgroundColor: '#ffffff',
      color: '#333333',
      lineHeight: '1.6',
      fontSize: '16px'
    }}>
      {/* Header */}
      <div style={{
        backgroundColor: '#f8f9fa',
        padding: '40px 20px',
        textAlign: 'center',
        borderBottom: '1px solid #e9ecef'
      }}>
        <img
          src="/apps/tictactoe-infinite/logo.png"
          alt="Tic Tac Toe Infinite Logo"
          style={{
            width: '64px',
            height: '64px',
            marginBottom: '20px',
            display: 'block',
            marginLeft: 'auto',
            marginRight: 'auto'
          }}
        />
        <h1 style={{
          fontSize: '2rem',
          fontWeight: '600',
          color: '#1a1a1a',
          margin: '0 0 8px 0'
        }}>
          Privacy Policy
        </h1>
        <p style={{
          fontSize: '18px',
          color: '#492061',
          margin: '0 0 8px 0',
          fontWeight: '500'
        }}>
          Tic Tac Toe - Infinite
        </p>
        <p style={{
          fontSize: '14px',
          color: '#666666',
          margin: '0'
        }}>
          Effective Date: July 12, 2025
        </p>
      </div>

      {/* Content */}
      <div style={{
        maxWidth: '720px',
        margin: '0 auto',
        padding: '32px 20px'
      }}>
        
        {/* Introduction */}
        <div style={{
          marginBottom: '32px',
          padding: '24px',
          backgroundColor: '#f8f9fa',
          borderRadius: '8px',
          border: '1px solid #e9ecef'
        }}>
          <p style={{
            fontSize: '16px',
            color: '#495057',
            margin: '0',
            fontWeight: '400'
          }}>
            Thank you for choosing <strong style={{ color: '#1a1a1a' }}>Tic Tac Toe – Infinite</strong>. 
            This Privacy Policy explains how we collect, use, and safeguard your personal information.
          </p>
        </div>

        {/* Section 1 */}
        <div style={{ marginBottom: '32px' }}>
          <h2 style={{
            fontSize: '1.25rem',
            fontWeight: '600',
            color: '#1a1a1a',
            marginBottom: '16px',
            paddingBottom: '8px',
            borderBottom: '1px solid #e9ecef'
          }}>
            Information We Collect
          </h2>
          <div style={{ paddingLeft: '0' }}>
            <div style={{ marginBottom: '16px' }}>
              <strong style={{ color: '#1a1a1a', fontSize: '15px' }}>Google Account Information:</strong>
              <span style={{ color: '#495057', marginLeft: '4px' }}>
                When you sign in with Google, we collect your name, email address, and profile picture.
              </span>
            </div>
            <div style={{ marginBottom: '16px' }}>
              <strong style={{ color: '#1a1a1a', fontSize: '15px' }}>Device Information:</strong>
              <span style={{ color: '#495057', marginLeft: '4px' }}>
                Device model, OS version, unique identifiers, and crash logs.
              </span>
            </div>
            <div style={{ marginBottom: '16px' }}>
              <strong style={{ color: '#1a1a1a', fontSize: '15px' }}>Gameplay Data:</strong>
              <span style={{ color: '#495057', marginLeft: '4px' }}>
                Scores and play activity for leaderboards when enabled.
              </span>
            </div>
            <div style={{ marginBottom: '16px' }}>
              <strong style={{ color: '#1a1a1a', fontSize: '15px' }}>Advertising Data:</strong>
              <span style={{ color: '#495057', marginLeft: '4px' }}>
                AdMob may collect anonymized identifiers and usage data for personalized ads. See{' '}
                <a href="https://support.google.com/admob/answer/6128543" 
                   target="_blank" 
                   rel="noopener noreferrer"
                   style={{ color: '#007bff', textDecoration: 'underline' }}>
                  AdMob's data practices
                </a>.
              </span>
            </div>
          </div>
        </div>

        {/* Section 2 */}
        <div style={{ marginBottom: '32px' }}>
          <h2 style={{
            fontSize: '1.25rem',
            fontWeight: '600',
            color: '#1a1a1a',
            marginBottom: '16px',
            paddingBottom: '8px',
            borderBottom: '1px solid #e9ecef'
          }}>
            How We Use Your Information
          </h2>
          <div style={{ color: '#495057' }}>
            <div style={{ marginBottom: '8px' }}>• Authenticate users via Google Sign-In</div>
            <div style={{ marginBottom: '8px' }}>• Match players in online multiplayer mode</div>
            <div style={{ marginBottom: '8px' }}>• Enable leaderboards and competitive features</div>
            <div style={{ marginBottom: '8px' }}>• Display relevant in-game advertisements</div>
            <div style={{ marginBottom: '8px' }}>• Enhance app performance and user experience</div>
          </div>
        </div>

        {/* Section 3 */}
        <div style={{ marginBottom: '32px' }}>
          <h2 style={{
            fontSize: '1.25rem',
            fontWeight: '600',
            color: '#1a1a1a',
            marginBottom: '16px',
            paddingBottom: '8px',
            borderBottom: '1px solid #e9ecef'
          }}>
            Third-Party Services
          </h2>
          <div style={{ color: '#495057' }}>
            <div style={{ marginBottom: '12px' }}>
              <strong style={{ color: '#1a1a1a' }}>Google AdMob:</strong> Used to display advertisements. 
              May collect device and usage data for ad personalization.
            </div>
            <div style={{ marginBottom: '12px' }}>
              <strong style={{ color: '#1a1a1a' }}>Google Sign-In:</strong> For user authentication 
              and basic profile information.
            </div>
          </div>
        </div>

        {/* Section 4 */}
        <div style={{ marginBottom: '32px' }}>
          <h2 style={{
            fontSize: '1.25rem',
            fontWeight: '600',
            color: '#1a1a1a',
            marginBottom: '16px',
            paddingBottom: '8px',
            borderBottom: '1px solid #e9ecef'
          }}>
            Data Retention
          </h2>
          <p style={{ color: '#495057', margin: '0' }}>
            We retain information only as necessary for user accounts and leaderboards. 
            You may request account or data deletion by contacting us.
          </p>
        </div>

        {/* Section 5 */}
        <div style={{ marginBottom: '32px' }}>
          <h2 style={{
            fontSize: '1.25rem',
            fontWeight: '600',
            color: '#1a1a1a',
            marginBottom: '16px',
            paddingBottom: '8px',
            borderBottom: '1px solid #e9ecef'
          }}>
            Children's Privacy
          </h2>
          <p style={{ color: '#495057', margin: '0' }}>
            This app is not directed at children under 13. We do not knowingly collect data from 
            users under 13; such data will be deleted if discovered.
          </p>
        </div>

        {/* Section 6 */}
        <div style={{ marginBottom: '32px' }}>
          <h2 style={{
            fontSize: '1.25rem',
            fontWeight: '600',
            color: '#1a1a1a',
            marginBottom: '16px',
            paddingBottom: '8px',
            borderBottom: '1px solid #e9ecef'
          }}>
            Security
          </h2>
          <p style={{ color: '#495057', margin: '0' }}>
            We implement reasonable technical safeguards to protect your information. However, 
            no method of data transmission or storage is completely secure.
          </p>
        </div>

        {/* Section 7 */}
        <div style={{ marginBottom: '32px' }}>
          <h2 style={{
            fontSize: '1.25rem',
            fontWeight: '600',
            color: '#1a1a1a',
            marginBottom: '16px',
            paddingBottom: '8px',
            borderBottom: '1px solid #e9ecef'
          }}>
            Policy Updates
          </h2>
          <p style={{ color: '#495057', margin: '0' }}>
            We may update this policy as new features are added or legal requirements change. 
            Updates will be indicated by a revised effective date.
          </p>
        </div>

        {/* Contact Section */}
        <div style={{
          padding: '24px',
          backgroundColor: '#f8f9fa',
          borderRadius: '8px',
          border: '1px solid #e9ecef',
          marginBottom: '32px'
        }}>
          <h2 style={{
            fontSize: '1.25rem',
            fontWeight: '600',
            color: '#1a1a1a',
            margin: '0 0 16px 0'
          }}>
            Contact Us
          </h2>
          <p style={{ color: '#495057', margin: '0 0 12px 0' }}>
            For questions or data deletion requests, email us at:
          </p>
          <a 
            href="mailto:support@tattvadynamics.com" 
            style={{
              color: '#007bff',
              textDecoration: 'none',
              fontSize: '16px',
              fontWeight: '500',
              borderBottom: '1px solid transparent'
            }}
            onMouseEnter={(e) => {
              if (e.target instanceof HTMLElement) {
                e.target.style.borderBottomColor = '#007bff';
              }
            }}
            onMouseLeave={(e) => {
              if (e.target instanceof HTMLElement) {
                e.target.style.borderBottomColor = 'transparent';
              }
            }}
          >
            support@tattvadynamics.com
          </a>
        </div>
      </div>

      {/* Footer */}
      <div style={{
        textAlign: 'center',
        padding: '24px 20px',
        backgroundColor: '#f8f9fa',
        borderTop: '1px solid #e9ecef',
        color: '#6c757d',
        fontSize: '14px'
      }}>
        <p style={{ margin: '0 0 8px 0' }}>
          © 2025 Tic Tac Toe – Infinite. All rights reserved.
        </p>
        <p style={{ margin: '0', fontSize: '12px' }}>
          Last updated: July 12, 2025 | Version 1.0
        </p>
      </div>
    </div>
  );
}